export default __webpack_public_path__ + "static/brand-1-3860536ad9b28781bcbc67ce32c059f6.png";